"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaPage = void 0;

require("react-app-polyfill/ie11");

require("react-app-polyfill/stable");

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactstrap = require("reactstrap");

var _jquery = _interopRequireDefault(require("jquery"));

var _MfaEntete = require("./MfaEntete");

var _MfaMenu = _interopRequireDefault(require("./MfaMenu"));

var _MfaPied = require("./MfaPied");

var _MfaPageDeconnexion = require("./MfaPageDeconnexion");

var _MfaPageTitre = _interopRequireDefault(require("./MfaPageTitre"));

var _MfaPageCorps = _interopRequireDefault(require("./MfaPageCorps"));

require("semantic-ui-css/semantic.min.css");

require("../css/mfa-page.css");

var _utilitaires = require("../utils/utilitaires");

var _utilitaires2 = require("../utils/utilitaires.requete");

var _MfaContexte = require("./MfaContexte");

var _MfaDialogue = require("./MfaDialogue");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaPage = /*#__PURE__*/function (_Component) {
  _inherits(MfaPage, _Component);

  var _super = _createSuper(MfaPage);

  function MfaPage(props) {
    var _this;

    _classCallCheck(this, MfaPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fermerSession", function () {
      sessionStorage.clear();
      localStorage.clear();

      _this.effacerCookiesFrontEnd();

      _this.effacerCookiesBackEnd();

      sessionStorage.setItem('deconnexion', true);

      _this.setState({
        deconnexion: true
      });
    });

    (0, _jquery.default)('head > title').text(_this.props.titre);
    var urlFonts = 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap\\';
    (0, _jquery.default)('head').append('<link href=\'' + urlFonts + '\' rel=\'stylesheet\'>');
    _this.state = {
      deconnexion: (0, _utilitaires.estDefini)(_this.props.deconnexion) ? _this.props.deconnexion : false,
      routesParent: (0, _utilitaires.estDefini)(_this.props.routesParent) ? _this.props.routesParent : null,
      routes: (0, _utilitaires.estDefini)(_this.props.routes) ? _this.props.routes : null,
      proprietesRoutes: _this.props.proprietesRoutes,
      afficherDialogue: true
    };
    return _this;
  }

  _createClass(MfaPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var deconnexion = sessionStorage.getItem('deconnexion');

      if (deconnexion) {
        this.fermerSession();
      }

      var routes = this.state.routes;

      if (!(0, _utilitaires.estDefini)(routes)) {
        this.chargerRoutes();
      }
    }
  }, {
    key: "chargerRoutes",
    value: function () {
      var _chargerRoutes = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var adresseRoutes, routesReponse, routes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                adresseRoutes = this.props.adresseRoutes;
                _context.next = 3;
                return (0, _utilitaires2.requete)(adresseRoutes, this.context);

              case 3:
                routesReponse = _context.sent;
                _context.next = 6;
                return routesReponse.json();

              case 6:
                routes = _context.sent;
                this.setState({
                  routes: routes
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function chargerRoutes() {
        return _chargerRoutes.apply(this, arguments);
      }

      return chargerRoutes;
    }()
  }, {
    key: "appliquerProprietesRoutes",
    value: function appliquerProprietesRoutes(routes) {
      var proprietesRoutes = this.state.proprietesRoutes;

      if (!(0, _utilitaires.estDefini)(proprietesRoutes)) {
        return;
      }

      routes.forEach(function (route) {
        var proprietes = proprietesRoutes[route.chemin];

        if (!(0, _utilitaires.estDefini)(proprietes)) {
          return;
        }

        Object.assign(route, proprietes);
      });
    }
  }, {
    key: "surSortie",
    value: function surSortie() {
      this.setState({
        afficherDialogue: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var routes = this.obtenirRoutesAvecAccueil();

      if (!(0, _utilitaires.estDefini)(routes)) {
        return null;
      }

      var dictionnaireRoutes = this.props.dictionnaireRoutes;
      var routesDefaut = routes.filter(function (routeMenu) {
        return routeMenu.estDefaut && routeMenu.chemin !== '/';
      });
      var routeDefaut = routesDefaut.length === 0 && routes.length === 0 ? null : routesDefaut.length === 0 ? routes[0] : routesDefaut[0];
      var deconnexion = this.state.deconnexion;

      if (deconnexion) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "mfa-racine"
        }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_MfaPageDeconnexion.MfaPageDeconnexion, null)));
      }

      var cheminUrlFin = '/';
      var cheminUrl = window.location.pathname + cheminUrlFin;
      routes.filter(function (c) {
        return (0, _utilitaires.nestPasNulOuVide)(c.cheminSource) && !c.cheminSource.endsWith(cheminUrlFin);
      }).forEach(function (r) {
        return r.cheminSource = r.cheminSource + cheminUrlFin;
      });
      routes.filter(function (c) {
        return !(0, _utilitaires.nestPasNulOuVide)(c.cheminSource);
      }).forEach(function (r) {
        return r.cheminSource = r.chemin + cheminUrlFin;
      });
      var pageDemandeeExiste = routes.find(function (elt) {
        return cheminUrl.includes(elt.cheminSource);
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-racine"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_MfaEntete.MfaEntete, {
        routes: routes,
        titre: this.props.titre,
        fermerSession: this.fermerSession,
        fermetureSessionInfo: this.props.fermetureSessionInfo
      })), /*#__PURE__*/_react.default.createElement(_reactstrap.Container, {
        className: "mfa-contenu"
      }, /*#__PURE__*/_react.default.createElement(_MfaPageCorps.default, {
        routes: routes,
        routeDefaut: routeDefaut
      }, /*#__PURE__*/_react.default.createElement(_MfaPageTitre.default, {
        routes: routes
      }), routeDefaut === null || routeDefaut.chemin === '/' ? null : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        from: "/",
        to: routeDefaut.chemin,
        exact: true
      })), !(0, _utilitaires.estDefini)(pageDemandeeExiste) ? /*#__PURE__*/_react.default.createElement(_MfaDialogue.MfaDialogue, {
        estVisible: this.state.afficherDialogue,
        surSortie: this.surSortie.bind(this),
        titre: 'Page introuvable',
        messageboutonSortie: 'Fermer',
        tailleIcone: "xl",
        couleurIcone: "red",
        nomIcone: "minus circle"
      }, /*#__PURE__*/_react.default.createElement("b", null, 'La page demandée est introuvable.')) : routes.filter(function (r) {
        return r.composante;
      }).map(function (route, index) {
        var Composante = route.composante;

        if (typeof Composante === 'string') {
          Composante = (0, _utilitaires.estDefini)(dictionnaireRoutes) ? dictionnaireRoutes[Composante] : null;
        }

        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
          path: route.chemin,
          key: index + route.chemin,
          component: Composante
        });
      }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_MfaPied.MfaPied, {
        courriel: this.props.courriel
      })));
    }
  }, {
    key: "obtenirRoutesAvecAccueil",
    value: function obtenirRoutesAvecAccueil() {
      var _this$state = this.state,
          routes = _this$state.routes,
          routesParent = _this$state.routesParent;

      if (!(0, _utilitaires.estDefini)(routes)) {
        return null;
      }

      routes = routes.map(function (r) {
        return r;
      });
      var accueil = {
        chemin: '/',
        description: 'Accueil',
        estDefaut: true,
        estLienMenu: false,
        parent: routesParent,
        groupe: 0
      };
      var routesSansChemin = routes.filter(function (r) {
        return !(0, _utilitaires.estDefini)(r.chemin);
      });
      var nombreRoutes = routesSansChemin.length;

      if (nombreRoutes > 0) {
        var s = nombreRoutes > 1 ? 's' : '';
        var noms = routesSansChemin.map(function (route) {
          return route.composante.name;
        }).join(', ');
        throw "Vous devez sp\xE9cifier un chemin pour chaque route. " + "".concat(nombreRoutes, " route").concat(s, " n'").concat(nombreRoutes > 1 ? 'ont' : 'a', " pr\xE9sentement pas de chemin. ") + "Le".concat(s, " nom").concat(s, " de ").concat(nombreRoutes > 1 ? '' : 'la ', "composante").concat(s, " pour ").concat(nombreRoutes > 1 ? 'ces' : 'cette', " route").concat(s, " ").concat(nombreRoutes > 1 ? 'sont' : 'est', ": ").concat(noms);
      }

      routes.filter(function (r) {
        return !r.parent;
      }).forEach(function (r) {
        return r.parent = accueil;
      });
      routes.filter(function (r) {
        return r.chemin;
      }).forEach(function (r) {
        return r.chemin = r.chemin.replace(/\/$/, '');
      });

      if ((0, _utilitaires.estDefini)(routesParent)) {
        routes.unshift(routesParent);
      }

      routes.unshift(accueil);
      this.appliquerProprietesRoutes(routes);
      return routes;
    }
  }, {
    key: "effacerCookiesFrontEnd",
    value: function () {
      var _effacerCookiesFrontEnd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var cookies, c, d, cookieBase, p;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cookies = document.cookie.split('; ');

                for (c = 0; c < cookies.length; c++) {
                  d = window.location.hostname.split('.');

                  while (d.length > 0) {
                    cookieBase = "".concat(encodeURIComponent(cookies[c].split(';')[0].split('=')[0]), "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=").concat(d.join('.'), " ;path=");
                    p = window.location.pathname.split('/');
                    document.cookie = "".concat(cookieBase, "/");

                    while (p.length > 0) {
                      document.cookie = cookieBase + p.join('/');
                      p.pop();
                    }

                    d.shift();
                  }
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function effacerCookiesFrontEnd() {
        return _effacerCookiesFrontEnd.apply(this, arguments);
      }

      return effacerCookiesFrontEnd;
    }()
  }, {
    key: "effacerCookiesBackEnd",
    value: function () {
      var _effacerCookiesBackEnd = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var optionsEntete, deconnexionBackEnd, retour;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                optionsEntete = {
                  method: 'POST',
                  cache: 'no-store'
                };
                _context3.next = 3;
                return (0, _utilitaires2.requete)(this.props.fermetureSessionInfo.urlApiDeconnexion, this.context, optionsEntete);

              case 3:
                deconnexionBackEnd = _context3.sent;
                _context3.next = 6;
                return deconnexionBackEnd;

              case 6:
                retour = _context3.sent;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function effacerCookiesBackEnd() {
        return _effacerCookiesBackEnd.apply(this, arguments);
      }

      return effacerCookiesBackEnd;
    }()
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(procahineProps, etatPrecedent) {
      var proprietesRoutes = etatPrecedent.proprietesRoutes;
      var prochaineProprietes = procahineProps.proprietesRoutes;

      if (!(0, _utilitaires.objetsEgaux)(proprietesRoutes, prochaineProprietes)) {
        return {
          proprietesRoutes: prochaineProprietes
        };
      }

      return null;
    }
  }]);

  return MfaPage;
}(_react.Component);

exports.MfaPage = MfaPage;

_defineProperty(MfaPage, "contextType", _MfaContexte.MfaContexte);